"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_STATUS_WAIT_FRAUD_MANUAL_CHECK = exports.ORDER_STATUS_SHIPPED = exports.ORDER_STATUS_READY_FOR_SHIPPING = exports.ORDER_STATUS_READY = exports.ORDER_STATUS_PROCESSING_ERROR = exports.ORDER_STATUS_PRINTED = exports.ORDER_STATUS_PAYMENT_PENDING = exports.ORDER_STATUS_PACKED = exports.ORDER_STATUS_ON_HOLD = exports.ORDER_STATUS_CREATED = exports.ORDER_STATUS_COMPLETED = exports.ORDER_STATUS_CHECK_VALID = exports.ORDER_STATUS_CHECK_INVALID = exports.ORDER_STATUS_CANCELLING = exports.ORDER_STATUS_CANCELLED = exports.DELIVERY_FULFILMENT_MODE = exports.CLICK_AND_COLLECT_FULFILMENT_MODE = void 0;
const ORDER_STATUS_CREATED = 'created';
exports.ORDER_STATUS_CREATED = ORDER_STATUS_CREATED;
const ORDER_STATUS_WAIT_FRAUD_MANUAL_CHECK = 'wait_fraud_manual_check';
exports.ORDER_STATUS_WAIT_FRAUD_MANUAL_CHECK = ORDER_STATUS_WAIT_FRAUD_MANUAL_CHECK;
const ORDER_STATUS_ON_HOLD = 'on_hold';
exports.ORDER_STATUS_ON_HOLD = ORDER_STATUS_ON_HOLD;
const ORDER_STATUS_CHECK_INVALID = 'checked_invalid';
exports.ORDER_STATUS_CHECK_INVALID = ORDER_STATUS_CHECK_INVALID;
const ORDER_STATUS_CHECK_VALID = 'checked_valid';
exports.ORDER_STATUS_CHECK_VALID = ORDER_STATUS_CHECK_VALID;
const ORDER_STATUS_PAYMENT_PENDING = 'payment_pending';
exports.ORDER_STATUS_PAYMENT_PENDING = ORDER_STATUS_PAYMENT_PENDING;
const ORDER_STATUS_READY = 'ready';
exports.ORDER_STATUS_READY = ORDER_STATUS_READY;
const ORDER_STATUS_PRINTED = 'printed';
exports.ORDER_STATUS_PRINTED = ORDER_STATUS_PRINTED;
const ORDER_STATUS_PACKED = 'packed';
exports.ORDER_STATUS_PACKED = ORDER_STATUS_PACKED;
const ORDER_STATUS_READY_FOR_SHIPPING = 'ready_for_shipping';
exports.ORDER_STATUS_READY_FOR_SHIPPING = ORDER_STATUS_READY_FOR_SHIPPING;
const ORDER_STATUS_SHIPPED = 'shipped';
exports.ORDER_STATUS_SHIPPED = ORDER_STATUS_SHIPPED;
const ORDER_STATUS_COMPLETED = 'completed';
exports.ORDER_STATUS_COMPLETED = ORDER_STATUS_COMPLETED;
const ORDER_STATUS_CANCELLED = 'cancelled';
exports.ORDER_STATUS_CANCELLED = ORDER_STATUS_CANCELLED;
const ORDER_STATUS_CANCELLING = 'cancelling';
exports.ORDER_STATUS_CANCELLING = ORDER_STATUS_CANCELLING;
const ORDER_STATUS_PROCESSING_ERROR = 'processing_error';
exports.ORDER_STATUS_PROCESSING_ERROR = ORDER_STATUS_PROCESSING_ERROR;
const DELIVERY_FULFILMENT_MODE = 'delivery';
exports.DELIVERY_FULFILMENT_MODE = DELIVERY_FULFILMENT_MODE;
const CLICK_AND_COLLECT_FULFILMENT_MODE = 'CnC';
exports.CLICK_AND_COLLECT_FULFILMENT_MODE = CLICK_AND_COLLECT_FULFILMENT_MODE;
//# sourceMappingURL=hybris-order-status.js.map